import { StyleSheet } from 'aphrodite';
import constants from '../../../../constants/styles';

let {
  STATUS_PARENT_BG_COLOR,
  STATUS_PARENT_HOVER_BG_COLOR,
  TABLE_BG_COLOR,
  STATUS_PARENT_VALUE_COLOR
} = constants;

let styles = {
  base: {
    display: 'flex',
    backgroundColor: STATUS_PARENT_BG_COLOR,
    padding: '20px 30px 25px',
    borderRadius: 8,
    position: 'relative',
    textTransform: 'uppercase',
    borderBottom: `1px solid ${TABLE_BG_COLOR}`,

    ':hover': {
      backgroundColor: STATUS_PARENT_HOVER_BG_COLOR
    }
  },
  noDataRow: {
    fontSize: '1.1em',
    color: STATUS_PARENT_VALUE_COLOR,
    paddingLeft: 1,
    paddingRight: 0,
    fontWeight: 'normal',
    width: 200,
    margin: '0 auto',
    textTransform: 'uppercase'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/status/common/noDataFound.styles.js